<template>
    <div class="menuandvideo">
        <div class="pro_customer">
            <img src="../../assets/lives/csm_bg.png" alt="">
            <div class="name_list">
                <div v-for="(item,index) in customerlist" @click="switchtab(index)"
                :class="index == i ?'is_choose':'not_choose'">{{item.nickname}}</div>
            </div>
            <div>
                <img :src="show" alt="" style="box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);">
            </div>
            <img src="../../assets/lives/cancel_csm.png" alt="" @click="excitcustomer">
        </div>
    </div>
</template>

<script>
import evaluate from "./evaluate.vue"
import videos from "./videos.vue"
export default {
  name: 'customer',
  components:{
    evaluate,
    videos
  },
  props: {
    
  },
  data() {
    return {
        customerlist:[],
        i:0,
        show:''
    }
  },
  mounted() {
    this.getroomcustomer()
  },
  methods: {
    excitcustomer(){
        this.$emit("excitcustomer",false)
    },
    
    //获取客服列表
    getroomcustomer(){
      this.$api.getroomcustomer().then(res=>{
        this.show = res.data.data[0].qrCodeUrl
        this.customerlist = res.data.data
      })
    },
    switchtab(val){
        this.show = this.customerlist[val].qrCodeUrl
        this.i = val
    },
  },
 
}
</script>
<style scoped>
.menuandvideo{
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    background-color: rgba(0, 0, 0, .7);
    z-index: 110;
}
.is_choose{
    background: linear-gradient(153deg, #04BAF3 0%, #256EE7 96%);
    color: #fff;
    width: 78px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 5px;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.name_list{
    float: left;
    width: 90%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin: 20px 5%;
}
.not_choose{
    width: 78px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: #ECECEC;
    border-radius: 5px;
    font-size: 14px;
    color: #555555;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.pro_customer{
    width: 22vw;
    height: 63vh;
    background-color: #fff;
    background-size: 100%;
    position: absolute;
    background-color: #c000;
    top: 15vh;
    left: 37vw;
}
.pro_customer>img:first-child{
     width: 22vw;
     vertical-align: middle;
}
.pro_customer>div:nth-child(3){
    width: 22vw;
    height: 40vh;
    background-color: #fff;
}
.pro_customer div img{
    width: 28vh;
    height: 28vh;
}
.pro_customer>img:last-child{
     width: 2vw;
}
</style>
